export var CLASSNAME_PREFIX = 'av-journey-completed';
export var TRANSLATION_CONTEXT = 'accountverification';
//# sourceMappingURL=componentConfig.js.map